import React, { useState, useEffect, useContext } from "react";
import { plantCurveApi } from "../../../../../api/Api";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/logo 2.png';
import EnergyChartPower from "../../../../../components/charts/energy_reporting/EnergyChartPower";
import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme, Button } from '@mui/material';
import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../api/AxiosApi'
import ExportExcel from "../../../../../components/exportExcel/ExportExcel1";
import ExportPdf from "../../../../../components/exportPdf/ExportPdf";


// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
  const pad = (num) => String(num).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};


// export default function PlantLogData() {
//     const { LoggedInUserInfo } = useContext(AuthenticationContext)
//     const { PrimaryColor } = useContext(AppThemeContext);


//     const now = new Date(); // Current date and time

//     // Set the startDate to 5:00 AM of the current date
//     const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0);

//     // Set the endDate to 8:00 PM (20:00) of the current date
//     const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0);

//     const [startDate, setStartDate] = useState(formatDateTime(initialStartDate)); // Set default start date
//     const [endDate, setEndDate] = useState(formatDateTime(initialEndDate)); // Set default end date

//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const { spacing, palette, shape: { borderRadius } } = useTheme();

//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     // Pagination States
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(10);

//     const [chartLabels, setChartLabels] = useState([]);
//     const [chartData, setChartData] = useState([]);
//     const [gradientFill, setGradientFill] = useState(null);

//     const credentials = {
//         LOGIN_ID: localStorage.getItem("LoginID") ?? "",
//         PASS_KEY: localStorage.getItem("KEY") || "xyz",
//         LOC_CODE: localStorage.getItem("LCODE") ?? "",
//         DT1: startDate,
//         DT2: endDate,
//         WEB_KEY: "WEBXYZ321"

//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await plantCurveApi(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             setError("Failed to fetch data. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//  const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.LOGIN_ID]);


//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Define keys to exclude (you can also define keys to include instead)
//     const excludeKeys = ["LOC_CODE"]; // Replace "key1", "key2" with actual keys you don't want to export

//     // Filter logData
//     const filteredLogData = logData.map((item) => {
//         const filteredItem = {};
//         Object.keys(item).forEach((key) => {
//             if (!excludeKeys.includes(key)) {
//                 filteredItem[key] = item[key]; // Include keys not in excludeKeys
//             }
//         });
//         return filteredItem;
//     });

//     // Get table headers from filteredLogData
//     const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];



//     const exportToExcel = async () => {
//         await ExportExcel(
//             ImageUrl,
//             logData,
//             startDate,
//             endDate,
//             "Plant Power Log",
//             LoggedInUserInfo
//         );
//     };



//     const exportToPDF = async () => {
//         await ExportPdf(
//             ImageUrl,
//             currentData,
//             startDate,
//             endDate,
//            "Plant Power Log",
//             LoggedInUserInfo,
//             logo,
//             tableHeaders

//         );
//     };


//     // Handle the changes when selecting a date
//     const handleStartDateChange = (value) => {
//         const newDate = new Date(value);
//         const formattedDate = formatDateTime(newDate);
//         setStartDate(formattedDate); // Update the start date with only hours and minutes
//     };

//     const handleEndDateChange = (value) => {
//         const newDate = new Date(value);
//         const formattedDate = formatDateTime(newDate);
//         setEndDate(formattedDate); // Update the end date with only hours and minutes
//     };

//     // Refresh data only when clicking "Show"
//     function onRefreshData() {
//         if (startDate.length !== 0 && endDate.length !== 0) {
//             fetchLogData(); // Fetch data only after clicking the button
//         } else {
//             alert("Please provide valid dates");
//         }
//     }

//     return (
//         <>


//             {/* <div className="my-2">
//                 <PlantEnergy />
//             </div> */}

//             <Grid container style={{ padding: "0", margin: "0" }}>


//                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

//                     <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
//                         {/* First Card */}
//                         <Stack
//                             component={Card}
//                             p={spacing(1)}
//                             sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
//                         >

//                             <div>

//                                 <div style={{
//                                     marginBottom: "5px",
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     gap: "16px",
//                                 }}>
//                                     {/* Left-side title */}
//                                     <div style={{ marginLeft: "7px", fontSize: "14px"}}>
//                                         Plant Power Log
//                                     </div>

//                                     {/* Right-side date pickers */}
//                                     <div style={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         gap: "10px"
//                                     }}>
//                                         <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                             <span>From:</span>
//                                             <input
//                                                 type="datetime-local"
//                                                 value={startDate.replace(" ", "T")}
//                                                 onChange={(e) => handleStartDateChange(e.target.value)}
//                                                 style={{
//                                                     padding: "2px 8px",
//                                                     borderRadius: "14px",
//                                                     border: "1px solid #ccc",
//                                                 }}
//                                             />
//                                         </label>
//                                         <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                             <span>To:</span>
//                                             <input
//                                                 type="datetime-local"
//                                                 value={endDate.replace(" ", "T")}
//                                                 onChange={(e) => handleEndDateChange(e.target.value)}
//                                                 style={{
//                                                     padding: "2px 8px",
//                                                     borderRadius: "14px",
//                                                     border: "1px solid #ccc",
//                                                 }}
//                                             />
//                                         </label>

//                                         <button onClick={fetchLogData} style={buttonStyle}>
//                                             Show
//                                         </button>
//                                         <button onClick={exportToExcel} style={exportButtonStyle}>
//                                             Excel
//                                         </button>
//                                         <button onClick={exportToPDF} style={exportButtonStyle2}>
//                                             PDF
//                                         </button>



//                                     </div>
//                                 </div>

//                                 <div style={{ padding: "10px" }}>
//                                     {/* Table */}
//                                     <div className="table-responsive">
//                                         <table className="table table-hover table-bordered">
//                                             <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                                                 <tr>
//                                                     <th style={tableHeading}> Sn. </th>
//                                                     <th style={tableHeading}> Date </th>
//                                                     <th style={tableHeading}>Load Total [KW]</th>
//                                                     <th style={tableHeading}>Inverter Total [KW]</th>
//                                                     <th style={tableHeading}>Solar Meter Total [KW]</th>
//                                                     <th style={tableHeading}> Mains Total [KW] </th>
//                                                     <th style={tableHeading}> DG Total [KW] </th>

//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {loading ? (
//                                                     <tr>
//                                                         <td colSpan={tableHeaders.length} className="text-center">
//                                                             Loading...
//                                                         </td>
//                                                     </tr>
//                                                 ) : currentData.length > 0 ? (
//                                                     currentData.map((item, rowIndex) => (
//                                                         <tr key={rowIndex}>

//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.SN ?? ""}
//                                                             </td>

//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.datet ?? ""}
//                                                             </td>

//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.TOTAL_LOAD_KW ?? ""}
//                                                             </td>

//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.TOT_INV_KW ?? ""}
//                                                             </td>
//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.TOT_SOLAR_METER_KW ?? ""}
//                                                             </td>
//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.TOT_MAINS_KW ?? ""}
//                                                             </td>

//                                                             <td className="text-center align-middle" style={tableBody}>
//                                                                 {item.TOT_DG_KW ?? ""}
//                                                             </td>




//                                                         </tr>
//                                                     ))
//                                                 ) : (
//                                                     <tr>
//                                                         <td colSpan={tableHeaders.length} className="text-center">
//                                                             No data available
//                                                         </td>
//                                                     </tr>
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>

//                                     {/* Pagination */}
//                                     <div style={{ textAlign: "right", marginTop: "10px" }}>
//                                             <button
//                                                 onClick={() => handlePageChange(currentPage - 1)}
//                                                 disabled={currentPage === 1}
//                                                 style={paginationButtonStyle}
//                                             >
//                                                 Previous
//                                             </button>

//                                             {[...Array(totalPages)].map((_, index) => {
//                                                 const isActive = currentPage === index + 1;
//                                                 return (
//                                                     <button
//                                                         key={index}
//                                                         onClick={() => handlePageChange(index + 1)}
//                                                         style={{
//                                                             ...paginationButtonStyle,
//                                                             backgroundColor: isActive ? "#356E35" : "white",
//                                                             color: isActive ? "#fff" : "#356E35",
//                                                         }}
//                                                     >
//                                                         {index + 1}
//                                                     </button>
//                                                 );
//                                             })}

//                                             <button
//                                                 onClick={() => handlePageChange(currentPage + 1)}
//                                                 disabled={currentPage === totalPages}
//                                                 style={paginationButtonStyle}
//                                             >
//                                                 Next
//                                             </button>
//                                         </div>
//                                 </div>
//                             </div>
//                         </Stack>


//                     </Stack>


//                 </Grid>

//             </Grid>





//         </>
//     );
// }



export default function PlantLogData() {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const { spacing } = useTheme();

  const now = new Date();
  const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0);
  const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0);

  const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
  const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
  const [logData, setLogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(8);

  const credentials = {
    LOGIN_ID: localStorage.getItem("LoginID") ?? "",
    LOC_CODE: localStorage.getItem("LCODE") ?? "",
    PASS_KEY: localStorage.getItem("KEY") ?? "",
    WEB_KEY: "WEBXYZ321",
    DT1: startDate,
    DT2: endDate,
  };

  const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LOC_CODE}&PASS_KEY=${credentials.PASS_KEY}&WEB_KEY=${credentials.WEB_KEY}`;

  // ✅ Helper to convert URL → Base64
  async function getBase64FromUrl(url) {
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  const fetchLogData = async () => {
    setLoading(true);
    setError(null);
    setLogData([]);
    try {
      const res = await plantCurveApi(credentials);
      if (res?.data && Array.isArray(res.data)) {
        setLogData(res.data);
      } else {
        setLogData([]);
      }
    } catch (err) {
      setError("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credentials.LOGIN_ID, startDate, endDate]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(logData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const tableHeaders = [
    { label: "SN", key: "SN" },
    { label: "Date", key: "datet" },
    { label: "Load Total [KW]", key: "TOTAL_LOAD_KW" },
    { label: "Inverter Total [KW]", key: "TOT_INV_KW" },
    { label: "Solar Meter Total [KW]", key: "TOT_SOLAR_METER_KW" },
    { label: "Mains Total [KW]", key: "TOT_MAINS_KW" },
    { label: "DG Total [KW]", key: "TOT_DG_KW" },
  ];

  // ✅ Excel Export
  const exportToExcel = async () => {
    const exportData = logData.map((item) => {
      let row = {};
      tableHeaders.forEach((header) => {
        row[header.label] = item[header.key] ?? "";
      });
      return row;
    });

    const logoBase64 = await getBase64FromUrl(ImageUrl);

    await ExportExcel(
      logoBase64,
      exportData,
      startDate,
      endDate,
      "Plant Power Log",
      LoggedInUserInfo
    );
  };


  // ✅ PDF Export
  const exportToPDF = async () => {
    const exportData = logData.map((item) => {
      let row = {};
      tableHeaders.forEach((header) => {
        row[header.label] = item[header.key] ?? "";
      });
      return row;
    });

    await ExportPdf(
      ImageUrl,
      exportData,
      startDate,
      endDate,
      `Plant Power Log`,
      LoggedInUserInfo,
      logo,
      tableHeaders.map(h => h.label) // only headings
    );
  };

  return (
    <>
      <CssBaseline />
      <Box bgcolor={"background.default"} py={spacing(1)}>
        <div>
          {/* Header with Filters + Export */}
          <div
            style={{
              marginBottom: "5px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            <div style={{ marginLeft: "7px", fontSize: "14px" }}>
              Plant Power Log
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <label>
                From:&nbsp;
                <input
                  type="datetime-local"
                  value={startDate.replace(" ", "T")}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={inputStyle}
                />
              </label>
              <label>
                To:&nbsp;
                <input
                  type="datetime-local"
                  value={endDate.replace(" ", "T")}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={inputStyle}
                />
              </label>

              <button onClick={fetchLogData} style={buttonStyle}>
                Show
              </button>

              <button onClick={exportToExcel} className="export-button">
                Excel
              </button>
              <button onClick={exportToPDF} className="export-button2">
                PDF
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover table-bordered">
              <thead className="text-center">
                <tr>
                  {tableHeaders.map((header) => (
                    <th key={header.key} style={tableHeading}>
                      {header.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={tableHeaders.length || 7} className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : currentData.length > 0 ? (
                  currentData.map((item, rowIndex) => (
                    <tr key={rowIndex}>
                      {tableHeaders.map((header) => (
                        <td key={header.key} className="text-center align-middle">
                          {item[header.key] ?? ""}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={tableHeaders.length || 7} className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={{ textAlign: "right", marginTop: "10px" }}>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              style={paginationButtonStyle}
            >
              Previous
            </button>

            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => handlePageChange(index + 1)}
                style={{
                  ...paginationButtonStyle,
                  backgroundColor: currentPage === index + 1 ? "#356E35" : "white",
                  color: currentPage === index + 1 ? "#fff" : "#356E35",
                }}
              >
                {index + 1}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={paginationButtonStyle}
            >
              Next
            </button>
          </div>
        </div>
      </Box>
    </>
  );
}


/* Styles */

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  marginBottom: "7px",
  border: "1px solid lightgray",
  padding: "3px",
  borderRadius: "7px"
};

const responsiveHeaderStyle = {
  fontWeight: "bold",
  margin: "0",
  display: "flex",
  flexWrap: "wrap"
};

const responsiveControlsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  justifyContent: "center",
};

const inputStyle = {
  padding: "2px 2px",
  borderRadius: "14px",
  border: "1px solid #ccc",
  // marginLeft: "5px",
  // fontSize: "10px",
};

const buttonStyle = {
  backgroundColor: "#007BFF",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "2px 9px",
  cursor: "pointer",
  fontSize: "10px",
};

const exportButtonStyle = {
  backgroundColor: "darkblue",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const exportButtonStyle2 = {
  backgroundColor: "#f44336",
  color: "#fff",
  border: "none",
  borderRadius: "14px",
  padding: "3px 9px",
  cursor: "pointer",
  fontSize: "11px",
};

const paginationButtonStyle = {
  backgroundColor: "white",
  color: "#356E35",
  border: "1px solid #ddd",
  padding: "5px 10px",
  borderRadius: "5px",
  margin: "0 5px",
  cursor: "pointer",
  fontSize: "14px",
};

const tableHeading = {
  color: "rgb(53, 110, 53)",
  padding: "12px 10px",
  fontSize: "14px",
  whiteSpace: "nowrap",
}

const tableBody = {
  padding: "5px",
  whiteSpace: "nowrap",
}